module.exports = __webpack_public_path__ + "public/img/tiku_cbg5select.6c1ca142.png";